__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "bekon-tracking";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@kermi/ui-library", "0.1.22", function() { return Promise.all([__webpack_require__.e(857), __webpack_require__.e(620), __webpack_require__.e(617), __webpack_require__.e(570), __webpack_require__.e(23), __webpack_require__.e(328), __webpack_require__.e(977)]).then(function() { return function() { return __webpack_require__(9977); }; }); });
			register("vue-i18n", "8.28.2", function() { return __webpack_require__.e(765).then(function() { return function() { return __webpack_require__(7146); }; }); });
			register("vue-router", "3.6.5", function() { return __webpack_require__.e(173).then(function() { return function() { return __webpack_require__(173); }; }); });
			register("vue", "2.7.16", function() { return __webpack_require__.e(471).then(function() { return function() { return __webpack_require__(5471); }; }); });
			register("vuetify/lib", "2.6.13", function() { return Promise.all([__webpack_require__.e(857), __webpack_require__.e(620), __webpack_require__.e(617), __webpack_require__.e(570), __webpack_require__.e(23), __webpack_require__.e(328), __webpack_require__.e(818)]).then(function() { return function() { return __webpack_require__(4818); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};